<template>
    <ul :class="clsx('menu', { 'animations-disabled': !animationEnabled })">
        <li
            class="menu-item animated-menu-item"
            v-for="(route, index) in routes"
            :key="route.title"
            :style="getAnimatedItemStyle(index)"
        >
            <MenuItem :route="route.route" :url="route.url" :hash="route.hash">{{ route.title }}</MenuItem>
        </li>
    </ul>
</template>

<script>
import clsx from 'clsx';
import MenuItem from './menu-item';

export default  {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
    routes: {
      type: Array,
      default: () => [],
    },
  },
  components: { MenuItem },
  methods: {
    clsx,
    getAnimatedItemStyle(index) {
      const offset = (index - (this.routes.length - 1) / 2) * 100;
      const delay = index * 0.1 + 1;

      return {
        '--offset': `${offset}px`,
        'animation-delay': `${delay}s`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.menu {
    display: flex;
    align-items: center;
    justify-content: center;

    &-item {
        &:not(:last-child) {
            margin-right: 13px;
        }
    }
}
.animated-menu-item {
    opacity: 0;
    animation: spread 1s linear forwards;
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .animated-menu-item {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes spread {
    0% {
        opacity: 0;
        transform: translateX(calc(var(--offset) * -1));
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>
